// extracted by mini-css-extract-plugin
export default {"Modal":"CandidateVideosModal_Modal__gulPv","Overlay":"CandidateVideosModal_Overlay__X8Pe+"};